/**
 * 常用方法汇总集
 * */
import check from './check.js'
import util from './util.js'
import number from './number.js'
import array from './array.js'

export default {
    check,
    util,
    number,
    array,
}
